module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lexa Roséan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Recipient of the Golden Broom award, "), _c('B', [_vm._v("Lexa Rosean")]), _vm._v(" is a Wiccan High Priestess and professional psychic consultant in NYC.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/178cWnm/tc-custom/9781466882553.jpg?1732052886452",
      "alt": "This image is the cover for the book Zodiac Spells"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Zodiac Spells\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In "), _c('i', [_vm._v("Zodiac Spells")]), _vm._v(", Lexa Rosean has put together her most exciting collection yet: a book that marries astrology with Wiccan practice. Here you will discover how different spells work for different sun signs and how to maximize a spell using your date, time, and place of birth. "), _c('br'), _c('br'), _vm._v("In this enchanting collection you will learn how:"), _c('br'), _c('br'), _vm._v("*Almonds can help a Virgo heal a minor illness"), _c('br'), _vm._v("*Mint, chocolate, and chili powder can help a Scorpio attract anyone"), _c('br'), _vm._v("*A Taurus can get money using thyme and spinach"), _c('br'), _vm._v("*A Gemini can use pistachio nuts and pomegranate seeds for flirtation and romance"), _c('br'), _vm._v("*Libras can use rose water, cardamom, caraway, and mint to achieve balance and success"), _c('br'), _vm._v("*What spells your zodiac sign should avoid--and when they're safe to use"), _c('br'), _vm._v("*And much more!"), _c('br'), _c('br'), _vm._v("Let \"the Martha Stewart of Witches\" guide you though these fun, enchanting spells that call for simple ingredients and easy steps.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Griffin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0